import { HStack, Text } from '@chakra-ui/react';
import React, { FC } from 'react';

import { Icon } from '@app/components/Icon';
import { TokenIcon } from '@app/components/TokenIcon';
import { Pair, PoolToken } from '@app/types/pool';
import { GiTwoCoins, GiFlameSpin } from 'react-icons/gi';
import { SiMediafire } from 'react-icons/si';

import s from './PoolTokensCell.module.scss';
import { getSymbol } from '@app/helpers/symbol';
import { Badge } from '@app/components/Badge';
import { getCurrencySymbol } from '@app/helpers/currency';
import { Token } from '@app/types/token';
import { VerifiedMemeBadge } from '@app/components/VerifiedMemeBadge';
import { VaultToken } from '@app/hooks/plugins/useVaults';

interface Props {
  token0: Pair['token0'] | PoolToken | VaultToken;
  token1: Pair['token1'] | PoolToken | VaultToken;
  isMain?: boolean;
  isNotVerified?: boolean;
  version?: number;
  isNew?: boolean;
  isVerifiedMeme?: boolean;
  isActivePool?: boolean;
  isNitroPool?: boolean;
}

export const PoolTokensCell: FC<Props> = ({
  token0,
  token1,
  isMain,
  isNotVerified,
  version,
  isNew,
  isVerifiedMeme,
  isActivePool,
  isNitroPool
}) => {
  const token0Symbol = getSymbol(
    getCurrencySymbol({
      contractAddress: token0.id,
      symbol: token0.symbol
    } as Token) as string
  );
  const token1Symbol = getSymbol(
    getCurrencySymbol({
      contractAddress: token1.id,
      symbol: token1.symbol
    } as Token) as string
  );

  return (
    <HStack gap={0}>
      <TokenIcon symbol={token0Symbol} />
      <TokenIcon symbol={token1Symbol} sx={{ transform: 'translateX(-6px)' }} />
      <Text fontSize="18px" fontWeight={500} lineHeight="26px" ml="0px">
        {token0Symbol}
      </Text>
      <Text fontSize="18px" fontWeight={500} lineHeight="26px">
        -
      </Text>
      <Text fontSize="18px" fontWeight={500} lineHeight="26px" mr={1}>
        {token1Symbol}
      </Text>
      {version && (
        <Text color="orange" ml="4px" mt="4px">
          v{version}
        </Text>
      )}
      <Icon name="coin" className={s.coinIcon} />
      {isMain && !isVerifiedMeme && (
        <Badge
          variant="verified"
          // label="Verified"
          tooltip="Verified pool"
          icon="star"
          ml={2}
        />
      )}
      {isVerifiedMeme && <VerifiedMemeBadge />}
      {isNotVerified && <div className={s.notVerified}>Not verified</div>}
      {isNew && <Badge variant="new" label="New" tooltip="New pool" ml={2} />}
      {isActivePool && (
        <Badge
          variant="active_pool"
          tooltip="Incentivized with KIM"
          ml={2}
          iconComponent={
            <GiTwoCoins size={20} color="var(--chakra-colors-orange)" />
          }
        />
      )}
      {isNitroPool && (
        <Badge
          variant="nitro_pool"
          tooltip="Nitro"
          ml={2}
          iconComponent={
            <SiMediafire size={20} color="var(--chakra-colors-nitro)" />
          }
        />
      )}
    </HStack>
  );
};
